var _excluded = ["contact"];

var _this = this;

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";
import PropTypes from "prop-types";
import { isFunction } from "underscore";
import classNames from "classnames";
import Avatar from "../elements/avatar";

var ContactDisplayCard = function ContactDisplayCard(_ref) {
  var contact = _ref.contact,
      props = _objectWithoutProperties(_ref, _excluded);

  var renderLink = function renderLink(component) {
    var link = props.link || "/contact/".concat(contact != null ? contact.id : undefined);

    if (!props.showNameLink || !(contact != null ? contact.id : undefined)) {
      return component;
    } else {
      return /*#__PURE__*/React.createElement("a", {
        href: link,
        "data-refer": props.referrer,
        target: props.target
      }, component);
    }
  };

  var isDeceased = contact.properties && contact.properties.deceased ? contact.properties.deceased.value : null;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames("et--contact-card", props.className),
    onClick: props.onClick,
    onMouseOver: props.onMouseOver,
    onMouseOut: props.onMouseOut
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames("et--contact-card--body fs-exclude-data", {
      "is-stacked": props.isStacked
    })
  }, contact.avatar && isFunction(props.avatar) ? _this.props.avatar(contact.avatar, _this.props.avatarSize, "et--contact-card--avatar") : renderLink( /*#__PURE__*/React.createElement(Avatar, {
    className: "et--contact-card--avatar",
    url: contact.avatar,
    width: props.avatarSize,
    name: contact.name
  })), /*#__PURE__*/React.createElement("div", {
    className: "et--contact-card--content",
    style: {
      width: "calc(100% - ".concat(props.avatarSize, "px)"),
      verticalAlign: props.align
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames("et--contact-card--name", {
      "is-deceased": isDeceased
    })
  }, renderLink( /*#__PURE__*/React.createElement("strong", null, props.formattedName)), isDeceased ? /*#__PURE__*/React.createElement("span", {
    className: "et--contact-card--deceased"
  }, "Deceased") : undefined, props.showClassYear ? /*#__PURE__*/React.createElement("div", {
    className: "et--contact-card--class"
  }, props.roleWithYear) : undefined, props.children ? /*#__PURE__*/React.createElement("div", {
    className: "et--contact-card--children"
  }, props.children) : undefined))));
};

ContactDisplayCard.propTypes = {
  contact: PropTypes.object,
  link: PropTypes.string,
  align: PropTypes.string,
  avatarSize: PropTypes.number,
  showClassYear: PropTypes.bool,
  showNameLink: PropTypes.bool,
  referrer: PropTypes.string,
  onMouseOver: PropTypes.func,
  onMouseOut: PropTypes.func,
  onClick: PropTypes.func,
  isStacked: PropTypes.bool,
  target: PropTypes.string
};
ContactDisplayCard.defaultProps = {
  showClassYear: true,
  showNameLink: true,
  avatarSize: 56,
  align: "middle",
  target: "_self"
};
export default ContactDisplayCard;